
import home from './home'
import doctor from './doctor'
import common from './common'
import invitation from './invitation'
import comment from './comment'

export default {
    home,
    doctor,
    common,
    invitation,
    comment
}